export default {
  addBatchNumber: 'Add Batch Number',
  editBatchNumber: 'Edit Batch Number',
  cancelBatchNumber: 'Cancel',
  openBatchNumber: 'Open',
  batchNumber: 'Batch Number',
  planedQty: 'Planned Qty',
  writeOffStatus: 'Status',
  plantCode: 'Plant Code',
  disableBatchNumberConfirmInfo: 'Are you sure to cancel this Batch Number?',
  errTitlePlannedQty: 'Planned Qty Error',
  errMsgPlannedQty: 'Planned Qty should be a digital number, PLS verify.',
  errTitleBatchNumberExist: 'Duplicate Batch Number',
  errMsgBatchNumberExist: 'The Batch Number already exist in the system.',
  enterScan: 'Enter',
  scanWarnFron:
    'Note: If the batch number does not exist in this dropdown list, Please go to the T-Hub configuration page to configure it',
  nfcUid: 'NFC UID',
  back: 'Back',
  reActive: 'Re-activated',
  confirm: 'Confirm',
  noResponse: 'Scan No Response',
  noPhysicalBuckle: 'No NFC Tag',
  scanSuccess: 'Record Success',
  undoSuccess: 'Undo Success',
  uidCollectionUndoRecord: 'UID Collection Undo Record',
  scanCount: 'Scan Count',
  lastScan: 'Last Scan',
  upc: 'UPC',
  undo: 'Undo',
  undoDate: 'Undo Date',
  undoSku: 'Undo SKU',
  undoUpc: 'Undo UPC',
  undoOperator: 'Undo Operator',
  createTime: 'Create Time',
  updateTime: 'Update Time',
  lastUpdate: 'Last Updated By',
  lastUploadTime: 'Last Upload Time',
  lastUpdateTime: 'Last Update Time',
  uploadDate: 'Last Upload Date',
  createDate: 'Create Date',
  updateDate: 'Last Update Date',
  plant: 'Plant',
  error_code_2207: 'The batch status must be open or scanning.',
  error_code_2208: 'This NFC UID does not exist in the T-Hub system and cannot be collected.',
  error_code_2209_fon: 'This NFC UID has already been collected/submitted under this batch number',
  error_code_2209_bac: 'and does not need to be resubmitted.',
  error_code_2210_fon: 'This NFC UID has already been collected/submitted under another batch number',
  error_code_2210_bac: 'and does not need to be resubmitted.',
  error_code_2211: 'Invalid UPC, PLS scan/input again.',
  positiveInteger: 'Planned Qty should be a positive integer.',
  batchStatus: 'Batch Status',
  disableDate: 'Disable Date',
  scanDate: 'Scan Date',
  disablementSubmitDate: 'Disablement Submit Date',
  scannedQty: 'Scanned Qty',
  noNfcTagQty: 'No NFC Tag Qty',
  scanNoResponseTagQty: 'Scan No Response Tag Qty',
  readableUidQty: 'Readable UID Qty',
  readableActiveUidQty: 'Readable-Active UID Qty',
  readableDisabledUidQty: 'Readable-Disabled UID Qty',
  actualSubmitQty: 'Actual Submit Qty',
  uploadBtnMsg: 'Upload & Submit Disable UID List',
  popOverMsgFon: 'Please be noted that your excel file should contains “Batch Number”and “NFC UID”',
  popOverMsgBac: '2 columns and other columns will be ignored in data processing.',
  taggedSku: 'Tagged SKU',
  division: 'Division',
  uidTaggingStatus: 'UID Tagging Status',
  uidStatusBefore: 'UID Status (Before)',
  uidStatusAfter: 'UID Status (After)',
  excption: 'Exception',
  sannerId: 'Scanner ID',
  disablementSubmitter: 'Disablement Submitter',
  disableOperator: 'Disable Operator',
  detail: 'Detail',
  error_code_2212:
    'The uploaded file should only contain the column headers "Batch Number"and "NFC UID".Please verify your uploaded file again.',
  tBatchNumber: 'The batch number',
  batchNumberDnotExist: 'does not exist in the system. Please verify your uploaded file again.',
  noScanBatch: 'The scanning for batch number',
  batchNumberNoScan:
    ' not yet completed. Please confirm and click the "Scan Complete" button before proceeding with the upload.',
  batchNumberAlreadyCf: 'has been closed for disablement and cannot be submitted.',
  tUid: 'The UID ',
  noExitBatch: 'does not exist in the system.Please verify your uploaded file again.',
  notInCurrentBatch: 'was not submitted under the specified batch number. Please verify your uploaded file again.',
  noUidDataBatch: 'do not have NFC UID data. Please verify your uploaded file again.',
  error_code_2214: 'Batch number or UID cannot be empty. Please verify your uploaded file again.',
  spcWordMsg: 'A file name can\'t contain any of the following characters: \\/:*?"<>|',
  noBelongData: 'belongs to another plant in T-HUB. Please verify your uploaded file again.',
  notTaggedUidQty: 'Not Tagged UID Qty'
}
